module.exports = __webpack_public_path__ + "img/step1.d8757aab.png";